import { EditorEntity } from '../../editor/editor.entity';
import { EditorRole } from '../../editor/editor.role.enum';
import { AuthModel } from './auth.model';

export interface AuthStateModel {
  isAuthenticated: boolean
  token: string | null
  editor: EditorEntity | null
}

export class LoginAction {
  static readonly type = '[Auth] Login';

  constructor(public payload: AuthModel, public redirectTo?: string | null) {
  }
}

export class LogoutAction {
  static readonly type = '[Auth] Logout';
}

export class CheckTokenAction {
  static readonly type = '[Auth] Check Token';
}

export class SetUserAndAuthStatus {
  static readonly type = '[Auth] Set User and Auth Status';

  constructor(public payload: {
    isAuthenticated: boolean
    userRole: EditorRole | null
  }) {
  }
}

export function normalizeInternalRedirect(url: string | null, fallback: string): string {
  if (!url) {
    return fallback;
  }

  try {
    const dummyBase = 'https://www.westermann.de';
    const parsed = new URL(url, dummyBase);

    if (parsed.origin !== dummyBase) {
      return fallback;
    }

    if (url.includes('\\') || url.startsWith('//')) {
      return fallback;
    }

    return parsed.pathname + parsed.search + parsed.hash;
  }
  catch {
    return fallback;
  }
}
